import React from 'react';
import { Route, IndexRoute } from 'react-router';
import { EXPERIMENT_MEMBERS_AREA } from './constants/experiments';
import Overlay from './components/overlay';
import AccountSuspendedPage from './containers/account-suspended-page';
import App from './containers/app';
import CategoriesLink from './containers/categories-link';
import CategoriesPage from './containers/categories-page';
import CategoriesPageHeader from './containers/categories-page-header';
import CategoryPage from './containers/category-page';
import CategoryPageHeader from './containers/category-page-header';
import CommentEditPage from './containers/comment-edit-page';
import CommentEditPageHeader from './containers/comment-edit-page-header';
import FollowersMenu from './containers/followers-menu';
import FollowersPage from './containers/followers-page';
import FollowingPage from './containers/following-page';
import InternalPageHeader, { InternalPageDesktopHeader } from './containers/internal-page-header';
import LoginPage from './containers/login-page';
import MembersMenu from './containers/members-menu';
import MembersPage from './containers/members-page';
import NotFoundPage from './containers/not-found-page';
import NotificationsPage from './containers/notifications-page';
import PostCreatePage from './containers/post-create-page';
import PostCreatePageHeader from './containers/post-create-page-header';
import PostEditPage from './containers/post-edit-page';
import PostEditPageHeader from './containers/post-edit-page-header';
import PostPage from './containers/post-page';
import ProfileNotificationsPage from './containers/profile-notifications-page';
import ProfilePage from './containers/profile-page';
import ProfilePosts from './containers/profile-posts';
import resultsPage from './containers/results-page';
import SearchDesktopHeader from './containers/search-header/search-desktop-header';
import SearchMobileHeader from './containers/search-header/search-mobile-header';
import SearchMenu from './containers/search-menu';
import SearchPage from './containers/search-page';
import forAuthenticatedOnly from './hoc/for-authenticated-only';
import forExperiment from './hoc/for-experiment';
import forMobileOnly from './hoc/for-mobile-only';
import requireAuth from './hoc/require-auth';
import requireNotBlocked from './hoc/require-not-blocked';

// DANGER!!! New routes can only be 4 chars length or shorter!
// If you are lucky you can take route from black listed slugs in - communities-node-server/app/services/slug-service.js

export default () =>
  <Route path="/" name="Wix Forum" component={App}>
    <Route
      path="404"
      breadcrumbIgnore
      components={{ main: NotFoundPage, simpleHeader: CategoriesPageHeader, desktopHeader: InternalPageDesktopHeader }}
    />
    {/*<Route path="create-category" name="Create Category" breadcrumbName="breadcrumbs.create-category" components={{ main: CategoryCreatePage, stickyHeader: CategoryCreatePageHeader, desktopHeader: InternalPageDesktopHeader, overlay: Overlay, background: '#ffffff' }}/>*/}
    <Route
      path="profiles/:userSlug"
      name="Profile"
      breadcrumbName=":userSlug"
      components={{
        main: ProfilePage,
        children: ProfilePosts,
        headroomHeader: InternalPageHeader,
        desktopHeader: InternalPageDesktopHeader,
        overlay: Overlay,
      }}
    />
    <Route path="profiles/:userSlug" name="Profile" breadcrumbName=":userSlug">
      <Route
        path="settings"
        name="Settings"
        breadcrumbName="breadcrumbs.profile-settings"
        components={{
          main: requireAuth(ProfileNotificationsPage),
          headroomHeader: InternalPageHeader,
          desktopHeader: InternalPageDesktopHeader,
        }}
      />
      <Route
        path="followers"
        name="Followers"
        breadcrumbName="breadcrumbs.followers"
        components={{
          main: FollowersPage,
          headroomHeader: InternalPageHeader,
          desktopHeader: InternalPageDesktopHeader,
          menu: FollowersMenu,
        }}
      />
      <Route
        path="following"
        name="Following"
        breadcrumbName="breadcrumbs.following"
        components={{
          main: FollowingPage,
          headroomHeader: InternalPageHeader,
          desktopHeader: InternalPageDesktopHeader,
          menu: FollowersMenu,
        }}
      />
    </Route>
    <Route
      path="notifications"
      name="Notifications"
      breadcrumbName="breadcrumbs.notifications"
      components={{
        main: NotificationsPage,
        stickyHeader: InternalPageHeader,
        desktopHeader: InternalPageDesktopHeader,
      }}
    />
    <Route
      path="members"
      name="Members"
      breadcrumbName="breadcrumbs.members"
      components={{
        main: MembersPage,
        headroomHeader: InternalPageHeader,
        desktopHeader: InternalPageDesktopHeader,
        menu: forAuthenticatedOnly(MembersMenu),
      }}
    />
    <Route
      path="search"
      name="Search"
      breadcrumbName="breadcrumbs.search"
      components={{
        main: SearchPage,
        headroomHeader: SearchMobileHeader,
        desktopHeader: SearchDesktopHeader,
        menu: forExperiment(EXPERIMENT_MEMBERS_AREA, () => null, SearchMenu),
      }}
    />
    <Route path="search" name="Search" breadcrumbName="breadcrumbs.search">
      <Route
        path="posts"
        breadcrumbIgnore
        components={{
          main: resultsPage('posts', 'members'),
          headroomHeader: SearchMobileHeader,
          desktopHeader: SearchDesktopHeader,
          menu: forExperiment(EXPERIMENT_MEMBERS_AREA, () => null, SearchMenu),
        }}
      />
      <Route
        path="members"
        breadcrumbIgnore
        components={{
          main: resultsPage('members', 'posts'),
          headroomHeader: SearchMobileHeader,
          desktopHeader: SearchDesktopHeader,
          menu: forExperiment(EXPERIMENT_MEMBERS_AREA, () => null, SearchMenu),
        }}
      />
    </Route>
    <Route
      path="login"
      name="Login"
      breadcrumbName="breadcrumbs.login"
      components={{ main: LoginPage, desktopHeader: InternalPageDesktopHeader }}
    />
    <Route
      path="account-suspended"
      name="Account Suspended"
      breadcrumbName="breadcrumbs.account-suspended"
      components={{
        main: AccountSuspendedPage,
        headroomHeader: InternalPageHeader,
        desktopHeader: InternalPageDesktopHeader,
      }}
    />
    <Route
      path=":categorySlug"
      name="Category"
      breadcrumbName=":categorySlug"
      components={{
        main: CategoryPage,
        headroomHeader: CategoryPageHeader,
        desktopHeader: InternalPageDesktopHeader,
        menu: forMobileOnly(CategoriesLink),
      }}
    />
    <Route path=":categorySlug" name="Category" breadcrumbName=":categorySlug">
      {/*<Route path="edit" name="Edit Category" breadcrumbName="breadcrumbs.edit-category" components={{ main: CategoryEditPage, stickyHeader: CategoryEditPageHeader, desktopHeader: InternalPageDesktopHeader, overlay: Overlay }}/>*/}
      <Route
        path="create-post"
        name="Create Post"
        breadcrumbName="breadcrumbs.create-post"
        components={{
          main: requireAuth(requireNotBlocked(PostCreatePage)),
          stickyHeader: PostCreatePageHeader,
          desktopHeader: InternalPageDesktopHeader,
        }}
      />
      <Route
        path=":postSlug"
        name="Post"
        breadcrumbName=":postSlug"
        components={{ main: PostPage, headroomHeader: InternalPageHeader, desktopHeader: InternalPageDesktopHeader }}
      />
      <Route path=":postSlug" name="Post" breadcrumbName=":postSlug">
        <Route
          path="edit"
          name="Edit Post"
          breadcrumbName="breadcrumbs.edit-post"
          components={{
            main: requireAuth(requireNotBlocked(PostEditPage)),
            stickyHeader: PostEditPageHeader,
            desktopHeader: InternalPageDesktopHeader,
          }}
        />
        <Route
          path="edit-comment/:commentId"
          name="Edit Comment"
          breadcrumbName="breadcrumbs.edit-comment"
          components={{
            main: requireAuth(requireNotBlocked(CommentEditPage)),
            stickyHeader: CommentEditPageHeader,
            desktopHeader: InternalPageDesktopHeader,
          }}
        />
      </Route>
    </Route>
    <IndexRoute
      breadcrumbIgnore
      components={{
        main: CategoriesPage,
        simpleHeader: CategoriesPageHeader,
        desktopHeader: InternalPageDesktopHeader,
        overlay: Overlay,
      }}
    />
    <Route
      path="*"
      breadcrumbIgnore
      components={{ main: NotFoundPage, simpleHeader: CategoriesPageHeader, desktopHeader: InternalPageDesktopHeader }}
    />
  </Route>;



// WEBPACK FOOTER //
// ./app/get-routes.js